import {NgModule} from '@angular/core';
import {AppointmentListComponent} from './list/appointment-list.component';
import {AppointmentRoutingModule} from './appointment-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import { AppointmentStatusPipe } from '../../shared/pipes/appointment-status.pipe';
import { CaseStatusPipe } from '../../shared/pipes/case-status.pipe';

@NgModule({
  declarations: [AppointmentListComponent],
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CommonModule,
    AppointmentRoutingModule,
  ],
  providers: [AppointmentStatusPipe, CaseStatusPipe]

})
export class AppointmentModule {
}
